import React from 'react'
import { Link } from 'chemistry'

const ProductCardBanner = props => {
  const { deskPic, mobPic, link } = props

  if (!deskPic) return null

  return (
    <div
      className='mxd-block-card mxd-block-card-banner mxd-block-card-responsive mxd-product-card-banner pl2'
      data-testid='product-card-banner'
    >
      <Link href={link} className='col-12' data-testid='product-card-link'>
        <picture>
          <source srcSet={deskPic} media='(min-width: 768px)' data-testid='desk-pic-src' />
          <source
            srcSet={mobPic || deskPic}
            media='(max-width: 767px)'
            style={{ objectFit: 'cover', height: '80px' }}
            data-testid='mob-pic-src'
          />
          <img className='col-12' alt='promo-card' src={mobPic} data-testid='img-pic-src' />
        </picture>
      </Link>
    </div>
  )
}

export default ProductCardBanner
